export const IAC_CONF_ANNOUNCEMENT_ID = "iac-conf-may-2025-announcement";
export const IAC_CONF_ANNOUNCEMENT_PRIMARY_LINK =
  "https://www.iacconf.com/?refid=in-product-placement&utm_campaign=10974390-FY25%20-%20WW%20-%20Virtual%20Event%20-%20IacConf%20-%20May%202025&utm_source=spacelift&utm_medium=referral&utm_content=In-Product%20Placement";
